import Vue from 'vue';
import App from './App';
import router from './router';
import VueSocketio from 'vue-socket.io';
import Vuex from 'vuex';
import vuexI18n from 'vuex-i18n';
import translationsEn from './i18n/en';
import translationsDe from './i18n/de';
import BootstrapVue from 'bootstrap-vue';
import FilterFormatTime from './filters/FormatTime';
import FilterNiceAmount from './filters/NiceAmount';
import FilterCurrency from './filters/Currency';
import store from './store';
import sockets from './api/sockets';
import loop from './api/loop';
import VuePaginate from 'vue-paginate';
import Events from './api/events';
import VueLocalStorage from 'vue-localstorage';
import VueCookie from 'vue-cookie';
import axios from 'axios';
import helper from './services/helper';
import './registerServiceWorker';
/* eslint-disable no-process-env */
const apiURL = process.env.NODE_ENV === 'production'
    ? 'https://vuemeanager.moches.de/'
    : `http://${process.env.HOST || 'localhost'}:3000`;
Vue.config.productionTip = false;
Vue.use(VueCookie);
Vue.use(BootstrapVue);
Vue.use(new VueSocketio({
    debug:      false && process.env.NODE_ENV !== 'production',
    connection: apiURL
}));
Vue.use(Vuex);
Vue.use(vuexI18n.plugin, store);
Vue.use(VueLocalStorage);

axios.interceptors.request.use(config => {
    let token = Vue.cookie.get('token');
    if (token) {
        config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
}, error => Promise.reject(error)
);

// add translations directly to the application
Vue.i18n.add('en', translationsEn);
Vue.i18n.add('de', translationsDe);

// set the start locale to use
Vue.i18n.set('de');

Vue.use({ install: helper });
Vue.use(VuePaginate);

Vue.filter('NiceAmount', FilterNiceAmount);
Vue.filter('FormatTime', FilterFormatTime);
Vue.filter('Currency', FilterCurrency);

/* eslint-disable no-new */
new Vue({
    el:         '#app',
    router,
    store,
    sockets,
    render:     h => h(App),
    created:    () => {
        Events.startTimer();
        store.dispatch('getAllAchievements');
        store.dispatch('getAllShops');
        store.dispatch('getAllManagers');
        store.dispatch('getAllUpgrades');
    },
    data: {
        interval:   null,
        backupTick: () => setInterval(loop.onTick, 480)
    },
    localStorage: {
        lastOnline: {
            type:    Number,
            default: 0
        }
    },
    methods: {
        updateOnlineStatus(e) {
            if (this.intercept !== null) {
                clearInterval(this.interval);
            }
            if (e.type === 'offline') {
                this.intercept = this.backupTick();
            }
        }
    },
    mounted() {
        window.addEventListener('online', this.updateOnlineStatus);
        window.addEventListener('offline', this.updateOnlineStatus);
        if (navigator.onLine === false) {
            this.updateOnlineStatus({ type: 'offline' });
        }
    },
    beforeDestroy() {
        window.removeEventListener('online', this.updateOnlineStatus);
        window.removeEventListener('offline', this.updateOnlineStatus);
    }
});
